import * as React from 'react';

import { METADATA_SEPARATOR, MetadataTypography } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/degree-home';

type Props = {
  withMetadataSeparator?: boolean;
};

const UnknownAvailabilityDescription: React.VFC<Props> = ({ withMetadataSeparator }) => {
  const descriptionComponent = (
    <MetadataTypography inline={withMetadataSeparator}>{_t('Availability to be confirmed')}</MetadataTypography>
  );

  return withMetadataSeparator ? (
    <React.Fragment>
      {METADATA_SEPARATOR}
      {descriptionComponent}
    </React.Fragment>
  ) : (
    descriptionComponent
  );
};

export default UnknownAvailabilityDescription;
